import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GameManager, gameManager } from 'src/app/game/businesslogic/GameManager';
import { SettingsManager, settingsManager } from 'src/app/game/businesslogic/SettingsManager';
import { TrialCard } from 'src/app/game/model/data/Trials';
import { CardRevealDirective } from 'src/app/ui/helper/CardReveal';
import { GhsLabelDirective } from 'src/app/ui/helper/label';
import { GhsTooltipDirective } from 'src/app/ui/helper/tooltip/tooltip';

@Component({
  imports: [CardRevealDirective, GhsLabelDirective, GhsTooltipDirective, NgClass],
  selector: 'ghs-trial-card',
  templateUrl: './trial-card.html',
  styleUrls: ['./trial-card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialCardComponent implements OnInit, OnChanges {
  readonly inputTrial = input.required<number>({ alias: 'trial' });
  get trial(): number {
    return this.inputTrial();
  }

  readonly inputEdition = input.required<string>({ alias: 'edition' });
  get edition(): string {
    return this.inputEdition();
  }

  readonly keep = input<boolean>(false);
  readonly flipped = input<boolean>(false);
  readonly reveal = input<boolean>(false);
  readonly disableFlip = input<boolean>(false);
  trialCard: TrialCard | undefined;

  revealed: boolean = false;
  animate: boolean = false;

  gameManager: GameManager = gameManager;
  settingsManager: SettingsManager = settingsManager;

  ngOnInit(): void {
    const editionData = gameManager.editionData.find((editionData) => editionData.edition === this.edition && editionData.trials);
    if (editionData) {
      this.trialCard = editionData.trials.find((trialCard) => trialCard.edition === this.edition && trialCard.cardId === this.trial);
    }
  }

  onChange(revealed: boolean) {
    this.revealed = revealed;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const flipped = changes['flipped'];
    if (flipped && !this.disableFlip() && flipped.currentValue && flipped.currentValue !== flipped.previousValue) {
      this.animate = true;
    }
  }
}
